import { DropdownMenuItem, DropdownMenuSeparator } from '@/components/ui/dropdown-menu';
import { Building2, HandHelping, Navigation, Shield, Sparkles } from 'lucide-react';
import { getAccessOptions, rememberAccess } from '@/lib/accessOptions';

const iconMap = {
  gestor: Shield,
  admin: Building2,
  auxiliar: HandHelping,
  ebi: Sparkles,
  movimentos: Navigation,
};

export const AccessMenuItems = ({ user, currentKey, navigate, includeSeparator = true }) => {
  const options = getAccessOptions(user).filter(option => option.key !== currentKey);
  if (options.length === 0) return null;

  return (
    <>
      {options.map(option => {
        const Icon = iconMap[option.key] || Building2;
        return (
          <DropdownMenuItem
            key={option.key}
            onClick={() => { rememberAccess(option); navigate(option.route); }}
            className="cursor-pointer"
            data-testid={`access-menu-${option.key}`}
          >
            <Icon className="w-4 h-4 mr-2" />{option.label}
          </DropdownMenuItem>
        );
      })}
      {includeSeparator && <DropdownMenuSeparator />}
    </>
  );
};
